// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"796fe326","165":"ba3be5f2","233":"3045365f","257":"952b63a2","293":"5e637e94","368":"75f6ba87","453":"53445244","541":"b591d29c","915":"999dfe60"}[chunkId] + ".chunk.js";
};